import { apiAuth } from "./base";

export function getAddonsAccessStat(params) {
  let api = apiAuth();
  return api.get('v1/customer-addons/access-logs', { params });
}

export function getAddonsList(params) {
  let api = apiAuth();
  return api.get('v1/customer-addons', { params });
}

export function getAddonsLogByDate(date) {
  let api = apiAuth();
  return api.get(`v1/customer-addons/access-logs/${date}`);
}
